////    CORE    ////
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

////    COMPONENTS    ////
import { IconModule, LoaderButtonModule } from '@helvetia/components'
import { AppRoutingModule } from 'src/app/app-routing.module'
import { MaterialImporterModule } from 'src/app/shared/material-importer/material-importer.module'
import { EditTypeSupportComponent } from './edit-type-support.component'
import { FlexLayoutModule } from '@angular/flex-layout'

@NgModule({
  declarations: [EditTypeSupportComponent],
  imports: [
    AppRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    IconModule,
    LoaderButtonModule,
    MaterialImporterModule
  ],
  exports: [EditTypeSupportComponent],
})
export class EditTypeSupportModule {}
